const { createSlice, createAsyncThunk, createDraftSafeSelector } = require("@reduxjs/toolkit");
import Axios from "axios";
import { mergeObject } from "src/utils";
import { FS } from "../other/constant";

const client = Axios.create({
  baseURL: "https://backend-nft-app.trava.finance",
});

export const fetchArmouryData = createAsyncThunk("armourySlice/fetchArmouryData", async (_, thunkAPI) => {
  await Promise.all([thunkAPI.dispatch(fetchCollectionMeta()), thunkAPI.dispatch(fetchArmouryRegistry({ page: 1 }))]);
});

export const fetchCollectionMeta = createAsyncThunk("armourySlice/fetchCollectionMeta", async () => {
  const res = await client.get("/v1/cores/meta").then((res) => res.data);
  return res;
});

export const fetchArmouryRegistry = createAsyncThunk("armourySlice/fetchArmouryRegistry", async (params) => {
  const { page, limit = 5, expMin, expMax, search, rarity, sort = "-exp", type } = params;
  const res = await client
    .get("/v1/cores", {
      params: {
        page,
        limit,
        expmin: expMin,
        expmax: expMax,
        search,
        rarity,
        sort,
        type,
      },
    })
    .then((res) => res.data);
  return res;
});

const initialState = {
  fetchArmouryDataStatus: FS.INITIAL,
  armouryStatistic: undefined,
  topBenefactor: undefined,
  armouryRegistry: undefined,
  armouryRegistryConfig: {
    page: 1,
    rowsPerPage: 5,
    order: "desc",
    orderBy: "exp",
    expMax: undefined,
    expMin: undefined,
    rarities: [],
    types: [],
    search: undefined,
  },
};

const armourySlice = createSlice({
  name: "armourySlice",
  initialState: initialState,
  reducers: {
    updateArmouryRegistryConfig: (state, action) => {
      state.armouryRegistryConfig = mergeObject(state.armouryRegistryConfig, action.payload);
    },
  },
  extraReducers: {
    [fetchArmouryData.pending](state, _) {
      state.fetchArmouryDataStatus = FS.FETCHING;
    },
    [fetchArmouryData.fulfilled](state, _) {
      if (state.fetchArmouryDataStatus !== FS.FAIL) {
        state.fetchArmouryDataStatus = FS.SUCCESS;
      }
    },

    [fetchCollectionMeta.fulfilled](state, action) {
      state.armouryStatistic = {
        rarities: {
          copper: action.payload.totalRarity1,
          silver: action.payload.totalRarity2,
          gold: action.payload.totalRarity3,
          diamond: action.payload.totalRarity4,
          crystal: action.payload.totalRarity5,
        },
        totalBurnedNFT: action.payload.totalBurnedNFT,
        totalNFT: action.payload.totalNFT,
        unopenedChests: action.payload.totalUnopenNFT,
      };
      state.topBenefactor = action.payload.topAddressOpenChests.sort(
        (i1, i2) => parseInt(i2.count) - parseInt(i1.count)
      );
    },
    [fetchCollectionMeta.rejected](state, _) {
      state.fetchArmouryDataStatus = FS.FAIL;
      state.armouryStatistic = undefined;
      state.topBenefactor = undefined;
    },

    [fetchArmouryRegistry.fulfilled](state, action) {
      state.armouryRegistry = {
        totalPages: action.payload.totalPages,
        totalArmouries: action.payload.totalDocs,
        list: action.payload.docs,
      };
    },
    [fetchArmouryRegistry.rejected](state, _) {
      state.fetchArmouryDataStatus = FS.FAIL;
      state.armouryRegistry = undefined;
    },
  },
});

export default armourySlice.reducer;
export const { updateArmouryRegistryConfig } = armourySlice.actions;

export const selectArmourySlice = (state) => state.armourySlice;

export const selectArmouryStatistic = createDraftSafeSelector(
  (state) => selectArmourySlice(state).armouryStatistic,
  (armouryStatistic) => {
    if (!armouryStatistic) return null;
    const trakCount = Object.entries(armouryStatistic.rarities).map((item) => item[1]);
    const trakPercentage = trakCount.map((item) => (item / armouryStatistic.totalNFT) * 100);
    return {
      trakCount,
      trakPercentage,
      totalNFT: armouryStatistic.totalNFT - armouryStatistic.totalBurnedNFT,
      unopenedChests: armouryStatistic.unopenedChests,
    };
  }
);

export const selectTopCommanders = createDraftSafeSelector(selectArmourySlice, (armourySlice) => {
  if (!armourySlice.topBenefactor) return null;
  return armourySlice.topBenefactor.slice(0, 3);
});
